var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7042 0.422033C23.4612 -0.120501 22.7667 -0.142203 22.4759 0.36995C21.1304 2.70936 18.7216 4.16769 15.9698 4.16769H12.4976C7.89693 4.16769 4.16429 7.90033 4.16429 12.501C4.16429 12.8048 4.19901 13.0956 4.2294 13.3908C6.99849 11.4073 10.9959 9.72325 16.6643 9.72325C17.0462 9.72325 17.3587 10.0357 17.3587 10.4177C17.3587 10.7996 17.0462 11.1121 16.6643 11.1121C5.75283 11.1121 1.1261 17.8005 0.101792 20.3135C-0.184666 21.021 0.153875 21.8283 0.86134 22.1191C1.57315 22.4142 2.38044 22.0713 2.67558 21.3682C2.74068 21.212 3.58269 19.2892 5.79624 17.4359C7.20249 19.3413 9.8761 21.1599 13.3874 20.7866C20.2016 20.2918 24.9976 14.1807 24.9976 6.69807C24.9976 4.51926 24.5289 2.26231 23.7042 0.422033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector-2.03c787d6eeb7fae0e57caa833232aac7.svg";
export { ForwardRef as ReactComponent };